import { SellFirstHelper } from "./SellFirstHelper";
import { PortOrBreak } from "./PortOrBreak";
import { ClosingCostsFlip } from "../UnclePosts";

// Interactive sections slotted after chapter N (1-based) on /mortgages/buy-a-home/.
export const BUY_HOME_EXTRAS = { 1: SellFirstHelper, 3: PortOrBreak, 4: ClosingCostsFlip };
